import AdbSwitch from './src/adb-switch.vue';

AdbSwitch.install = function (Vue) {
  Vue.component(AdbSwitch.name, AdbSwitch);
};

export default AdbSwitch;
